import React from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import trustAppLogo from '../assets/images/logo.png';

const createRewardCardImage = (rewardAmount) => new Promise((resolve, reject) => {
  const canvas = document.createElement('canvas');
  canvas.width = 1080;
  canvas.height = 1350;

  const context = canvas.getContext('2d');
  if (!context) {
    reject(new Error('Canvas is not supported by this browser.'));
    return;
  }

  const drawRoundedRect = (x, y, width, height, radius, color) => {
    context.beginPath();
    context.roundRect(x, y, width, height, radius);
    context.fillStyle = color;
    context.fill();
  };

  const drawJobIcon = (x, y) => {
    context.save();
    context.translate(x, y);
    context.strokeStyle = '#ffffff';
    context.lineWidth = 4;
    context.lineCap = 'round';
    context.lineJoin = 'round';
    context.beginPath();
    context.roundRect(-13, -7, 26, 19, 3);
    context.moveTo(-6, -7);
    context.lineTo(-6, -12);
    context.lineTo(6, -12);
    context.lineTo(6, -7);
    context.moveTo(-13, 0);
    context.lineTo(13, 0);
    context.moveTo(-3, 0);
    context.lineTo(-3, 4);
    context.lineTo(3, 4);
    context.lineTo(3, 0);
    context.stroke();
    context.restore();
  };

  const drawBroadcastIcon = (x, y) => {
    context.save();
    context.translate(x, y);
    context.strokeStyle = '#ffffff';
    context.fillStyle = '#ffffff';
    context.lineWidth = 3;
    context.lineCap = 'round';
    context.lineJoin = 'round';
    context.beginPath();
    context.moveTo(-13, -5);
    context.lineTo(0, -10);
    context.lineTo(0, 10);
    context.lineTo(-13, 5);
    context.closePath();
    context.moveTo(-13, -5);
    context.lineTo(-13, 5);
    context.moveTo(-9, 5);
    context.lineTo(-5, 13);
    context.lineTo(0, 13);
    context.stroke();
    context.beginPath();
    context.arc(0, 0, 8, -Math.PI / 3, Math.PI / 3);
    context.stroke();
    context.beginPath();
    context.arc(0, 0, 15, -Math.PI / 3, Math.PI / 3);
    context.stroke();
    context.restore();
  };

  const drawPlayStoreMark = (x, y, size) => {
    context.save();
    context.translate(x, y);
    context.scale(size / 40, size / 44);
    context.beginPath();
    context.moveTo(0, 0);
    context.lineTo(20, 22);
    context.lineTo(0, 44);
    context.closePath();
    context.fillStyle = '#00a7ff';
    context.fill();
    context.beginPath();
    context.moveTo(0, 0);
    context.lineTo(40, 22);
    context.lineTo(20, 22);
    context.closePath();
    context.fillStyle = '#00c853';
    context.fill();
    context.beginPath();
    context.moveTo(0, 44);
    context.lineTo(20, 22);
    context.lineTo(40, 22);
    context.closePath();
    context.fillStyle = '#ffca28';
    context.fill();
    context.beginPath();
    context.moveTo(20, 22);
    context.lineTo(40, 22);
    context.lineTo(33, 27);
    context.closePath();
    context.fillStyle = '#ff5252';
    context.fill();
    context.restore();
  };

  const logoImage = new Image();
  logoImage.onload = () => {
  const background = context.createLinearGradient(0, 0, 1080, 1350);
  background.addColorStop(0, '#0f172a');
  background.addColorStop(0.55, '#1e3a8a');
  background.addColorStop(1, '#312e81');
  context.fillStyle = background;
  context.fillRect(0, 0, canvas.width, canvas.height);

  context.globalAlpha = 0.12;
  context.fillStyle = '#93c5fd';
  context.beginPath();
  context.arc(950, 180, 150, 0, Math.PI * 2);
  context.fill();
  context.beginPath();
  context.arc(80, 1160, 190, 0, Math.PI * 2);
  context.fill();
  context.globalAlpha = 1;

  drawRoundedRect(60, 70, 960, 1210, 48, '#ffffff');

  context.save();
  context.beginPath();
  context.roundRect(120, 115, 72, 72, 18);
  context.clip();
  context.drawImage(logoImage, 120, 115, 72, 72);
  context.restore();

  context.textAlign = 'left';
  context.fillStyle = '#0f172a';
  context.font = '800 44px Arial, sans-serif';
  context.fillText('TrustApp', 215, 153);
  context.fillStyle = '#64748b';
  context.font = '700 20px Arial, sans-serif';
  context.fillText('Get 400 services in one app', 217, 183);

  drawRoundedRect(690, 116, 280, 72, 18, '#0f172a');
  drawPlayStoreMark(710, 130, 34);
  context.fillStyle = '#cbd5e1';
  context.font = '700 13px Arial, sans-serif';
  context.fillText('GET IT ON', 756, 143);
  context.fillStyle = '#ffffff';
  context.font = '700 24px Arial, sans-serif';
  context.fillText('Google Play', 756, 170);

  context.textAlign = 'center';
  context.fillStyle = '#334155';
  context.font = '600 32px Arial, sans-serif';
  context.fillText('Earn cash rewards and send to your UPI', 540, 310);

  const rewardPanel = context.createLinearGradient(120, 0, 960, 0);
  rewardPanel.addColorStop(0, '#0f172a');
  rewardPanel.addColorStop(0.55, '#1e40af');
  rewardPanel.addColorStop(1, '#4338ca');
  drawRoundedRect(115, 330, 850, 610, 42, rewardPanel);

  context.textAlign = 'left';
  context.font = '700 26px Arial, sans-serif';
  const freeAppTagWidth = context.measureText('FREE app').width + 84;
  const freeAppTagX = 965 - freeAppTagWidth - 32;
  drawRoundedRect(freeAppTagX, 355, freeAppTagWidth, 60, 30, '#fde68a');
  context.beginPath();
  context.arc(freeAppTagX + 30, 385, 17, 0, Math.PI * 2);
  context.fillStyle = '#b45309';
  context.fill();
  context.strokeStyle = '#ffffff';
  context.lineWidth = 3;
  context.lineCap = 'round';
  context.lineJoin = 'round';
  context.beginPath();
  context.moveTo(freeAppTagX + 22, 386);
  context.lineTo(freeAppTagX + 28, 392);
  context.lineTo(freeAppTagX + 39, 378);
  context.stroke();
  context.fillStyle = '#78350f';
  context.fillText('FREE app', freeAppTagX + 58, 394);

  context.fillStyle = '#bfdbfe';
  context.font = '700 28px Arial, sans-serif';
  context.textAlign = 'center';
  context.fillText('MY REWARDS', 540, 430);

  context.fillStyle = '#ffffff';
  context.font = '800 132px Arial, sans-serif';
  context.fillText(`₹${new Intl.NumberFormat('en-IN').format(rewardAmount)}`, 540, 590);

  context.fillStyle = '#dbeafe';
  context.font = '500 30px Arial, sans-serif';
  const earnedPrefix = 'Earned on ';
  const earnedUrl = 'www.TrustApp.in';
  const earnedPrefixWidth = context.measureText(earnedPrefix).width;
  const earnedUrlWidth = context.measureText(earnedUrl).width;
  const earnedLineStart = 540 - (earnedPrefixWidth + earnedUrlWidth) / 2;
  context.textAlign = 'left';
  context.fillText(earnedPrefix, earnedLineStart, 650);
  context.fillStyle = '#facc15';
  context.fillText(earnedUrl, earnedLineStart + earnedPrefixWidth, 650);
  context.textAlign = 'center';

  context.textAlign = 'left';
  context.font = '700 34px Arial, sans-serif';
  const jobTagWidth = context.measureText('Get local job faster').width + 118;
  const jobTagX = (canvas.width - jobTagWidth) / 2;
  drawRoundedRect(jobTagX, 710, jobTagWidth, 72, 36, '#a7f3d0');
  context.beginPath();
  context.arc(jobTagX + 38, 746, 23, 0, Math.PI * 2);
  context.fillStyle = '#047857';
  context.fill();
  drawJobIcon(jobTagX + 38, 746);
  context.fillStyle = '#064e3b';
  context.fillText('Get local job faster', jobTagX + 78, 758);

  const broadcastTagWidth = context.measureText('Broadcast to earn money').width + 118;
  const broadcastTagX = (canvas.width - broadcastTagWidth) / 2;
  drawRoundedRect(broadcastTagX, 805, broadcastTagWidth, 72, 36, '#fde68a');
  context.beginPath();
  context.arc(broadcastTagX + 38, 841, 23, 0, Math.PI * 2);
  context.fillStyle = '#b45309';
  context.fill();
  drawBroadcastIcon(broadcastTagX + 38, 841);
  context.fillStyle = '#78350f';
  context.fillText('Broadcast to earn money', broadcastTagX + 78, 853);

  context.textAlign = 'center';
  context.fillStyle = '#0f172a';
  context.font = '700 26px Arial, sans-serif';
  context.fillText('Run 400 types business from TrustApp.', 540, 980);
  context.font = '600 24px Arial, sans-serif';
  context.fillStyle = '#4338ca';
  context.fillText('Visit our YouTube channel for more details,', 540, 1020);
  context.fillText('link available in app and website', 540, 1050);

  canvas.toBlob((blob) => {
    if (blob) resolve(blob);
    else reject(new Error('Unable to create the reward card image.'));
  }, 'image/png');
  };
  logoImage.onerror = () => reject(new Error('Unable to load the TrustApp logo.'));
  logoImage.src = trustAppLogo;
});

export const downloadRewardCardImage = async (rewardAmount) => {
  const image = await createRewardCardImage(rewardAmount);
  const imageUrl = URL.createObjectURL(image);
  const downloadLink = document.createElement('a');
  downloadLink.href = imageUrl;
  downloadLink.download = `trustapp-reward-${rewardAmount}.png`;
  document.body.appendChild(downloadLink);
  downloadLink.click();
  downloadLink.remove();
  window.setTimeout(() => URL.revokeObjectURL(imageUrl), 1000);
};

const RewardShareCard = () => {
  const [searchParams] = useSearchParams();
  const amountParam = searchParams.get('amount');
  const parsedRewardAmount = Number(amountParam);
  const rewardAmount = Number.isFinite(parsedRewardAmount) && parsedRewardAmount >= 0
    ? parsedRewardAmount
    : 0;
  const [downloadMessage, setDownloadMessage] = React.useState('');

  const handleDownload = async () => {
    setDownloadMessage('');
    try {
      await downloadRewardCardImage(rewardAmount);
      setDownloadMessage('Reward card image downloaded. You can post it on Instagram, X, or other apps.');
    } catch (error) {
      console.error('Failed to create reward card image:', error);
      setDownloadMessage('Unable to create the reward card image. Please try another browser.');
    }
  };

  return (
    <div style={{
      minHeight: '100vh',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      background: 'linear-gradient(135deg, #fef3c7 0%, #f59e0b 35%, #7c3aed 100%)',
      padding: '24px',
      fontFamily: 'Inter, sans-serif',
    }}>
      <div style={{
        width: '100%',
        maxWidth: '420px',
        background: 'rgba(255,255,255,0.96)',
        borderRadius: '24px',
        padding: '28px 22px',
        boxShadow: '0 18px 45px rgba(0,0,0,0.18)',
        border: '1px solid rgba(255,255,255,0.7)',
      }}>
        <Link
          to="/utility-dashboard"
          style={{
            display: 'block',
            marginBottom: '20px',
            borderRadius: '12px',
            background: '#0f172a',
            color: '#ffffff',
            fontSize: '1rem',
            fontWeight: '700',
            padding: '14px 18px',
            textAlign: 'center',
            textDecoration: 'none',
            boxShadow: '0 6px 14px rgba(15, 23, 42, 0.22)',
          }}
        >
          ← Back to TrustApp Home
        </Link>
        <div style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          gap: '10px',
          marginBottom: '18px',
        }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: '9px', minWidth: 0 }}>
            <img src={trustAppLogo} alt="" style={{ width: '48px', height: '48px', borderRadius: '12px', objectFit: 'cover' }} />
            <div>
              <div style={{ color: '#0f172a', fontSize: '1rem', fontWeight: '800' }}>TrustApp</div>
              <div style={{ color: '#64748b', fontSize: '0.68rem', fontWeight: '700', letterSpacing: '0.5px' }}>REWARDS</div>
            </div>
          </div>
          <div style={{
            display: 'flex',
            alignItems: 'center',
            gap: '7px',
            padding: '7px 9px',
            borderRadius: '10px',
            background: '#0f172a',
            color: '#ffffff',
            flexShrink: 0,
          }}>
            <svg aria-hidden="true" viewBox="0 0 40 44" width="23" height="25">
              <path d="M2 1 21 22 2 43Z" fill="#00a7ff" />
              <path d="M2 1 38 22H21Z" fill="#00c853" />
              <path d="M2 43 21 22h17Z" fill="#ffca28" />
              <path d="m21 22 17 0-7 5Z" fill="#ff5252" />
            </svg>
            <span style={{ lineHeight: 1.1 }}>
              <span style={{ display: 'block', fontSize: '0.54rem', color: '#cbd5e1' }}>GET IT ON</span>
              <span style={{ display: 'block', fontSize: '0.75rem', fontWeight: '700' }}>Google Play</span>
            </span>
          </div>
        </div>

        <div style={{
          background: 'linear-gradient(135deg, #0f172a 0%, #1d4ed8 100%)',
          borderRadius: '22px',
          padding: '26px 18px',
          color: '#fff',
          textAlign: 'center',
          marginBottom: '18px',
          boxShadow: 'inset 0 0 20px rgba(255,255,255,0.08)',
        }}>
          <div style={{ fontSize: '0.8rem', opacity: 0.9, letterSpacing: '1px', textTransform: 'uppercase' }}>
            I earned
          </div>
          <div style={{ fontSize: '3rem', fontWeight: '900', lineHeight: 1.1, margin: '10px 0 0' }}>
            ₹{rewardAmount}
          </div>
          <div style={{ fontSize: '0.92rem', marginTop: '10px', opacity: 0.95 }}>
            Earned on <span style={{ color: '#facc15', fontWeight: '700' }}>www.TrustApp.in</span>
          </div>
          <div style={{
            marginTop: '18px',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            gap: '10px',
            fontSize: '0.88rem',
            fontWeight: '700',
          }}>
            <div style={{
              minHeight: '38px',
              padding: '6px 14px',
              borderRadius: '999px',
              maxWidth: '100%',
              background: '#a7f3d0',
              color: '#064e3b',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              gap: '10px',
              boxShadow: '0 3px 8px rgba(0,0,0,0.12)',
            }}>
              <svg aria-hidden="true" viewBox="0 0 24 24" width="22" height="22" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <rect x="3" y="8" width="18" height="12" rx="2" />
                <path d="M8 8V5h8v3M3 12h18M10 12v2h4v-2" />
              </svg>
              Get local job faster
            </div>
            <div style={{
              minHeight: '38px',
              padding: '6px 14px',
              borderRadius: '999px',
              maxWidth: '100%',
              background: '#fde68a',
              color: '#78350f',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              gap: '10px',
              boxShadow: '0 3px 8px rgba(0,0,0,0.12)',
            }}>
              <svg aria-hidden="true" viewBox="0 0 24 24" width="22" height="22" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <path d="M3 10v4h4l5 4V6l-5 4H3zM16 9a5 5 0 0 1 0 6M18 6a9 9 0 0 1 0 12" />
              </svg>
              Broadcast to earn money
            </div>
          </div>
        </div>

        <p style={{
          textAlign: 'center',
          fontSize: '0.92rem',
          lineHeight: 1.6,
          color: '#334155',
          margin: '0 0 20px',
        }}>
          Download the image to post it on Instagram, X, or other apps.
        </p>

        <button
          onClick={handleDownload}
          style={{
            width: '100%',
            border: 'none',
            borderRadius: '12px',
            background: 'linear-gradient(135deg, #2563eb, #1d4ed8)',
            color: '#fff',
            fontSize: '1rem',
            fontWeight: '700',
            padding: '14px 18px',
            cursor: 'pointer',
            boxShadow: '0 10px 20px rgba(37, 99, 235, 0.25)',
          }}
        >
          Download reward image
        </button>
        {downloadMessage && (
          <p role="status" style={{ margin: '12px 0 0', textAlign: 'center', fontSize: '0.82rem', color: '#475569' }}>
            {downloadMessage}
          </p>
        )}

      </div>
    </div>
  );
};

export default RewardShareCard;
